import { AppSettings } from "@/settings"

import { checkPermissions, getAssignedCustomers } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getBranchOfficesTitle } from "../../shared/utils/getBranchOffice"
import { enrichCustomers } from "../utils/additionalData"

export const queryAllAssignedCustomers = {
  async allAssignedCustomers(_parent, args, context, _info) {
    const { lang = AppSettings.defaultLocale(), cdn = true } = args
    const { user } = context

    const domainObject = args?.includeRevenue ? DomainObjects.MAILING_LIST : DomainObjects.CUSTOMERS

    await checkPermissions({
      user,
      domainObject: domainObject,
      operation: Operations.READ,
    })

    const customers = await getAssignedCustomers({
      admNumber: user?.loggedInAdm.admNumber,
    })

    if (!customers || customers.length === 0) {
      return null
    }

    const branchOffices = await getBranchOfficesTitle(lang, context, cdn)

    return enrichCustomers(customers, args?.includeRevenue, branchOffices)
  },
}
